import {Controller} from "@hotwired/stimulus"


export default class extends Controller {
    connect() {
        this.syncWithHash()
        window.addEventListener('hashchange', this.hashHandler);
    }

    syncWithHash() {
        const id = window.location.hash.slice(1);
        const element = this.element;

        if (element instanceof HTMLDetailsElement) {
            const wasOpen = element.open;
            element.open = (id === element.id);
            if (element.open && !wasOpen) {
                // Ensure the element is scrolled into view if it was opened by hash
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    // we need this to keep the "this" context in the event listener
    private hashHandler = () => this.syncWithHash();

    disconnect() {
        // avoid memory leaks with window listeners!
        window.removeEventListener('hashchange', this.hashHandler);
    }
}
